import { module as BaseModule } from "modujs";
import { createElement } from "react";
import { createRoot } from "react-dom/client";
import NavigationComponent from "../components/Navigation.jsx";

export default class Navigation extends BaseModule {
  init() {
    this.rootEl = this.el.querySelector("[data-navigation-target]") || this.el;
    this.props = this.parseProps();
    this.mountReact();
  }

  parseProps() {
    const rawProps = this.el.getAttribute("data-navigation-props");

    const baseProps = { items: [], variant: "primary" };

    if (!rawProps) {
      return baseProps;
    }

    try {
      const parsed = JSON.parse(rawProps);
      return { ...baseProps, ...parsed };
    } catch (error) {
      console.warn("Failed to parse navigation props:", error);
      return baseProps;
    }
  }

  mountReact() {
    if (!this.rootEl) {
      return;
    }

    if (!this.reactRoot) {
      this.reactRoot = createRoot(this.rootEl);
    }

    this.reactRoot.render(createElement(NavigationComponent, this.props));
  }

  destroy() {
    if (this.reactRoot) {
      this.reactRoot.unmount();
      this.reactRoot = null;
    }

    this.rootEl = null;
    this.props = null;
  }
}
